import { unwrapResult } from "@reduxjs/toolkit"
import {
  Button,
  Col,
  Form,
  Input,
  Modal,
  notification,
  Row,
  Select,
  Space,
  Table,
  Upload,
} from "antd"
import React, {
  forwardRef,
  ReactElement,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react"
import { useDispatch, useSelector } from "react-redux"
import { RootDispatch } from "../../../app/store"
import { TabBar, TabPane } from "../../../compnents/widgets/TabBar"
import { ThemeContext } from "../../../theme/ThemeContext"
import styles from "./teantInfo.module.css"
import axios from "axios"
import { AXIOS_IP, beforeUpload, customRequest, getTeantDetailAsync } from "../fileUploadService"
import { CloseOutlined, PlusOutlined } from "@ant-design/icons"
import { selectCredentials, selectTenantName } from "../../../app/applicationSlice"
import { getSJWHTokenAsync } from "../../dataMaintenance/organization/data"
import { PreviewImgOrPdf } from "../Preview"

const { Option } = Select

export const TeantInfoRef = (): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  const theme = useContext(ThemeContext)

  const tenantName = useSelector(selectTenantName)

  const credentials: any = useSelector(selectCredentials)

  const [form] = Form.useForm()

  const ref = useRef<any>(null)

  const [currentTab, setCurrentTab] = useState("0")

  const [loading, setLoading] = useState<any>(false)

  const [visible, setVisible] = useState<any>(false)

  const [confirmLoading, setConfirmLoading] = useState(false)

  const [fileUrl, setfileUrl] = useState<any>([])

  const [token, setToken] = useState("")

  const [previewFile, setPreviewFile] = useState<any>() //预览

  const [detail, setDetail] = useState<any>() //预览

  const getData = () => {
    setLoading(true)
    dispatch(getSJWHTokenAsync())
      .then(unwrapResult)
      .then((token: any) => {
        setToken(token)
        dispatch(getTeantDetailAsync())
          .then(unwrapResult)
          .then((res: any) => {
            setDetail(res)
            axios({
              url: `${AXIOS_IP}/tenant/detailLicence`,
              headers: {
                "Content-Type": "application/json",
                "His-Auth": token,
              },
              data: {
                code: res?.tenant?.nationUniqueCode
              },
              withCredentials: false,
              method: "POST",
            }).then((d: any) => {
              setLoading(false)
              setfileUrl(d?.data?.data?.licenceUrlList || [])
            }).finally(() => {
              setLoading(false)
            })
          })
      })
  }

  // 自定义上传实现
  const customRequestFn = (options: any, type: string) => {
    customRequest(options, AXIOS_IP, (data: any) => {
      const newurl = {
        fileConfigId: data?.configId,
        fileName: data?.name,
        fileType: data?.type,
        filePath: data?.path,
      }
      setfileUrl([...fileUrl, newurl])
    })
  }

  const handleRemove = (index: number) => {
    setfileUrl(fileUrl?.filter((v: any, i: number) => i !== index))
  }

  useEffect(() => { 
    form.setFieldsValue({
      licenceUrlList: fileUrl,
    })
  }, [fileUrl])

  useEffect(() => {
    getData()
  }, [])

  return (
    <>
      <TabBar
        className={styles.tabs}
        activeKey={currentTab}
        onChange={(t) => setCurrentTab(t)}
      >
        <TabPane tab="机构信息" key="0">
          <Col className={styles.content}>
            <Col
              style={{
                flex: 1,
                backgroundColor: theme.pn,
                borderRadius: 10,
                display: "flex",
                flexDirection: "column",
                padding: "10px 20px",
              }}
            >
              <Row>机构名称：{ tenantName?.split('-')?.[0] }</Row>
              <Row style={{ marginTop: 10 }}>
                营业执照/许可证：
                {fileUrl?.length > 0 &&
                      fileUrl?.map((v: any, index: number) => {
                        return (
                          <div
                            key={index}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              cursor: "pointer",
                              paddingRight: 10,
                            }}
                          >
                            <span style={{ paddingRight: 10 }}>
                              {v.fileName}{" "}
                              <a
                                style={{ paddingLeft: 10 }}
                                onClick={() => setPreviewFile(v)}
                              >
                                查看
                              </a>
                            </span>
                          </div>
                        )
                      })}
              </Row>
              <Row style={{ marginTop: 30, display: "flex",justifyContent: "center" }} onClick={() => {
                form.setFieldsValue({
                  name: tenantName?.split('-')?.[0],
                })
                setVisible(true)
              }}>
                <Button type="primary">更新信息</Button>
              </Row>
            </Col>
          </Col>
        </TabPane>
      </TabBar>

      <Modal
        title="机构信息编辑"
        width={600}
        visible={visible}
        onCancel={() => {
          setVisible(false)
        }}
        onOk={form.submit}
        okText="提交"
        centered
        maskClosable={false}
        confirmLoading={confirmLoading}
      >
        <div>
          <Form
            form={form}
            labelCol={{ span: 6 }}
            wrapperCol={{ span: 18 }}
            onFinish={(vs) => {
              setConfirmLoading(true)
              const data = {
                licenceUrlList: vs?.licenceUrlList,
                code: detail?.tenant?.nationUniqueCode,
                name: credentials?.userName
              }
              axios({
                url: `${AXIOS_IP}/tenant/licenceAdd`,
                headers: {
                  "Content-Type": "application/json",
                  "His-Auth": token,
                },
                withCredentials: false,
                method: "POST",
                data,
              })
                .then(() => {
                  notification.success({
                    message: "操作成功",
                  })
                  setVisible(false)
                  axios({
                    url: `${AXIOS_IP}/tenant/detailLicence`,
                    headers: {
                      "Content-Type": "application/json",
                      "His-Auth": token,
                    },
                    data: {
                      code: detail?.tenant?.nationUniqueCode
                    },
                    withCredentials: false,
                    method: "POST",
                  }).then((d: any) => {
                    setLoading(false)
                    setfileUrl(d?.data?.data?.licenceUrlList || [])
                  }).finally(() => {
                    setLoading(false)
                  })
                })
                .finally(() => {
                  setConfirmLoading(false)
                })
            }}
          >
            <Row>
              <Col span={24}>
                <Form.Item
                  name="name"
                  label="机构名称"
                >
                  <Input allowClear disabled />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Form.Item
                  label="营业执照/许可证"
                  name="licenceUrlList"
                  rules={[
                    { required: true, message: "请上传营业执照/许可证" },
                  ]}
                >
                  <Row align="middle">
                    <Upload
                      customRequest={(options) =>
                        customRequestFn(options, "FG")
                      }
                      beforeUpload={(file) => beforeUpload(file, fileUrl)}
                      showUploadList={false}
                      maxCount={1}
                      accept={".jpg,.jpeg,.png,.gif"}
                    >
                      <Button icon={<PlusOutlined />}>上传</Button>
                    </Upload>
                    <span style={{ padding: "0 10px 0 15px" }}>
                      支持jpg,png图片格式
                    </span>
                    {fileUrl?.length > 0 &&
                      fileUrl?.map((v: any, index: number) => {
                        return (
                          <div
                            key={index}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              cursor: "pointer",
                              paddingRight: 10,
                            }}
                          >
                            <span style={{ paddingRight: 10 }}>
                              {v.fileName}{" "}
                              <a
                                style={{ paddingLeft: 10 }}
                                onClick={() => setPreviewFile(v)}
                              >
                                查看
                              </a>
                            </span>
                            <CloseOutlined
                              style={{
                                position: "relative",
                                top: 2,
                                color: "rgb(161 161 161)",
                              }}
                              onClick={() => {
                                handleRemove(index)
                              }}
                            />
                          </div>
                        )
                      })}
                  </Row>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </div>
      </Modal>

      <PreviewImgOrPdf
        token={token}
        AXIOS_IP={AXIOS_IP}
        file={previewFile}
        onClose={() => setPreviewFile(null)}
      />
    </>
  )
}
